import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=a7c7ed4c&scoped=true&"
import script from "./Viewer.vue?vue&type=script&lang=js&"
export * from "./Viewer.vue?vue&type=script&lang=js&"
import style0 from "./Viewer.vue?vue&type=style&index=0&id=a7c7ed4c&prod&lang=css&"
import style1 from "./Viewer.vue?vue&type=style&index=1&id=a7c7ed4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c7ed4c",
  null
  
)

export default component.exports